import axios from 'axios';
import apiConfig from '../api.config';

export default function guestFormsRequest(id) {
  const {
    host,
    URIs: { guestForms },
  } = apiConfig;

  const uri = `${host}${guestForms.replace(':hotelId', id)}`;

  return axios
    .get(uri, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(res => {
      return res.data;
    });
}
